module.exports = "<project-context project-id=\"{{ row.entity.id }}\" is-draft=\"row.entity.isDraft\" project=\"row.entity\"></project-context>"


//////////////////
// WEBPACK FOOTER
// ./src/app/authorized/projects/projects-list/templates/projectActions.tpl.html
// module id = 1821
// module chunks = 0